// extracted by mini-css-extract-plugin
export default {"vetRecommendedPlan":"ypLgD8","icon":"k9PoP5"};